<script setup>
import { computed, ref } from 'vue';
import { useAdmin } from 'dashboard/composables/useAdmin';
import { useMapGetter } from 'dashboard/composables/store';
import LabelDropdown from 'shared/components/ui/label/LabelDropdown.vue';
import AddLabel from 'shared/components/ui/dropdown/AddLabel.vue';

// v-model: array de títulos de label (mismo formato que Chatwoot usa para
// las labels de una conversación). Reusa el picker nativo con creación en
// caliente (LabelDropdown + AddLabel + woot-label).
const selected = defineModel({ type: Array, default: () => [] });

const { isAdmin } = useAdmin();
const accountLabels = useMapGetter('labels/getLabels');

const showDropdown = ref(false);
const toggle = () => {
  showDropdown.value = !showDropdown.value;
};
const close = () => {
  showDropdown.value = false;
};

const activeLabels = computed(() =>
  accountLabels.value.filter(label => selected.value.includes(label.title))
);

const titleOf = label => (typeof label === 'string' ? label : label.title);

const addLabel = label => {
  const title = titleOf(label);
  if (!title || selected.value.includes(title)) return;
  selected.value = [...selected.value, title];
};

const removeLabel = label => {
  const title = titleOf(label);
  selected.value = selected.value.filter(t => t !== title);
};
</script>

<template>
  <div v-on-clickaway="close" class="relative flex flex-wrap items-center gap-1">
    <AddLabel @add="toggle" />
    <woot-label
      v-for="label in activeLabels"
      :key="label.id"
      :title="label.title"
      :description="label.description"
      :color="label.color"
      variant="smooth"
      show-close
      small
      @remove="removeLabel"
    />
    <div
      :class="{
        'block visible': showDropdown,
        'hidden invisible': !showDropdown,
      }"
      class="absolute box-border z-[9999] w-full p-2 border rounded-lg shadow-lg top-7 bg-n-alpha-3 backdrop-blur-[100px] border-n-strong"
    >
      <LabelDropdown
        v-if="showDropdown"
        :account-labels="accountLabels"
        :selected-labels="selected"
        :allow-creation="isAdmin"
        @add="addLabel"
        @remove="removeLabel"
      />
    </div>
  </div>
</template>
